<template>
  <div id="data-view">
    <dv-full-screen-container>
      <top-header @onClick="dialogVisible = true" />

      <div class="main-content">
        <!-- <scroll-board /> -->
        <div class="col" style="flex: 1">
          <div class="col" style="flex: 3">
            <section-title title="天泽成交量"></section-title>
            <dv-border-box-7
              class="mt10 fill"
              :color="['#091d45', '#3f96a5']"
              backgroundColor="#091d45"
            >
              <div class="div-main"><turnover :data="turnoverItems"></turnover></div>
            </dv-border-box-7>
          </div>
          <div class="col" style="flex: 2; margin-top: 10px">
            <dv-border-box-8 backgroundColor="#091d45">
              <div class="div-main">
                <company-summary :data="summaryMap"></company-summary>
              </div>
            </dv-border-box-8>
          </div>
        </div>
        <div class="col" style="flex: 2; margin: 0 10px">
          <div class="col" style="flex: 3">
            <section-title title="天泽交易"> </section-title>
            <dv-border-box-7
              class="mt10 fill"
              :color="['#091d45', '#3f96a5']"
              backgroundColor="#091d45"
            >
              <div class="div-main">
                <order :data="orderItems"></order>
              </div>
            </dv-border-box-7>
          </div>
          <div class="col" style="flex: 2; margin-top: 10px">
            <section-title title="天泽指数"> </section-title>
            <dv-border-box-7
              class="mt10 fill"
              :color="['#091d45', '#3f96a5']"
              backgroundColor="#091d45"
            >
              <div class="div-main">
                <tz-index :data="indexItems"></tz-index></div
            >
          </dv-border-box-7>
          </div>
        </div>
        <div class="col" style="flex: 1">
          <section-title title="天泽竞价"> </section-title>
          <dv-border-box-7
            class="mt10 fill"
            :color="['#091d45', '#3f96a5']"
            backgroundColor="#091d45"
          >
            <div class="div-main">
              <bidding v-if="bidItems.length>0" :items="bidItems" :scrollSpeed="1"></bidding></div
          >

        </dv-border-box-7>
        </div>
      </div>
    </dv-full-screen-container>

    <!--  -->
    <el-dialog title="数据" :visible.sync="dialogVisible" width="30%">
      <div>交易金额：<span style="color:red">{{originTotalAmount}}</span>万元，交易数：<span style="color:red">{{ originOrderCount }}</span></div>
      <el-input
        type="textarea"
        v-model="textareaContent"
        placeholder="请输入内容"
        rows="10"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import topHeader from './topHeader'
import sectionTitle from './sectionTitle.vue'
import Turnover from './turnover.vue'
import CompanySummary from './companySummary.vue'
import Order from './order.vue'
import TzIndex from './tzIndex.vue'
import Bidding from './bidding.vue'
import { get, post } from '../../utils/fetch'
import { parse } from '../../utils/parse'

function obfuscateString (str) {
  if (str.length <= 2) {
    return str // 如果长度小于等于4，则不进行替换
  }

  const firstTwo = str.slice(0, 1) // 前两个字母
  const lastTwo = str.slice(-1) // 最后两个字母
  const middle = '*'.repeat(str.length - 2) // 中间部分替换为星号

  return firstTwo + middle + lastTwo
}

var intervalId

export default {
  name: 'DataView',
  components: {
    topHeader,
    sectionTitle,
    Turnover,
    CompanySummary,
    Order,
    TzIndex,
    Bidding
  },
  data () {
    return {
      turnoverItems: [],
      bidItems: [],
      orderItems: [],
      indexItems: [],
      summaryMap: { registerMember: 0, newAdditionToday: 0, corporateMember: 0, vipMember: 0, todayInquiryVolume: 0, inquiryVolumeThisMonth: 0 },
      dialogVisible: false,
      textareaContent: '',
      originOrderCount: 0,
      originTotalAmount: 0
    }
  },
  mounted () {
    this.getData()
    intervalId = setInterval(() => {
      this.getData()
    }, 1000 * 300)
  },
  destroyed () {
    clearInterval(intervalId)
  },
  methods: {
    async handleSubmit () {
      this.dialogVisible = false
      // 在这里处理提交的内容
      let res0 = ''
      if (this.textareaContent !== '') {
        res0 = JSON.parse(this.textareaContent)
      }
      // 调接口修改数据
      // await post('http://127.0.0.1:8081/tz/price/update', res0)
      await post('https://tz.admin.tianzesk.com/tz/price/update', res0)

      this.getData()
    },

    async getData () {
      // console.info("----getData-----");
      //
      const defSummaryObj = {
        registerMember: 0,
        newAdditionToday: 0,
        corporateMember: 0,
        vipMember: 0,
        todayInquiryVolume: 0,
        inquiryVolumeThisMonth: 0
      }
      const defSummary = JSON.stringify(defSummaryObj)

      let summary = localStorage.getItem('summary')
      let localSummary = null
      let hasValidLocalSummary = false
      if (summary) {
        try {
          const parsed = JSON.parse(summary)
          if (parsed && typeof parsed === 'object') {
            localSummary = parsed.data
            hasValidLocalSummary = true
          }
        } catch (e) {
          hasValidLocalSummary = false
        }
      }
      let chengjiao = 0; let jiaoyishu = 0
      if (hasValidLocalSummary) {
        // console.info("----localSummary-----", localSummary);
        this.summaryMap = {
          registerMember: localSummary['registerMember'] || 0, // 注册会员
          newAdditionToday: localSummary['newAdditionToday'] || 0, // 今日新增
          corporateMember: localSummary['corporateMember'] || 0, // 企业会员
          vipMember: localSummary['vipMember'] || 0, // vip会员
          todayInquiryVolume: localSummary['todayInquiryVolume'] || 0, // 问询量(今日)
          inquiryVolumeThisMonth: localSummary['inquiryVolumeThisMonth'] || 0 // 问询量(本月)
        }
      } else {
        this.summaryMap = { ...defSummaryObj }
        summary = null
      }

      // 优先使用 localStorage 中的 summary；只有没取到/无效时才请求接口，并且不再缓存接口数据
      let res0 = null
      if (!summary) {
        res0 = await get('https://tz.admin.tianzesk.com/tz/price/new')
        // res0 = await get('http://127.0.0.1:8081/tz/price/new')
        // console.info("----getData res0-----", res0);
        if (res0 && res0.data) {
          // res0.data 可能是 JSON 字符串，需先解析
          let data = res0.data
          if (typeof data === 'string') {
            try { data = JSON.parse(data) } catch (e) { data = {} }
          }
          this.summaryMap = {
            registerMember: data['registerMember'] || 0,
            newAdditionToday: data['newAdditionToday'] || 0,
            corporateMember: data['corporateMember'] || 0,
            vipMember: data['vipMember'] || 0,
            todayInquiryVolume: data['todayInquiryVolume'] || 0,
            inquiryVolumeThisMonth: data['inquiryVolumeThisMonth'] || 0
          }
        }
      }
      // this.summaryMap = {...localSummary,...this.summaryMap}
      // res0.data 可能是对象或 JSON 字符串，统一转为对象再序列化
      let dataObj = res0 && res0.data
      if (typeof dataObj === 'string') {
        try { dataObj = JSON.parse(dataObj) } catch (e) { /* 忽略 */ }
      }
      this.textareaContent = summary || JSON.stringify(dataObj) || defSummary.data
      // 天泽竞价: http://39.105.195.111:9005/getJiajia
      // 天泽指数: http://39.105.195.111:9005/getData
      // 天泽交易: http://39.105.195.111:9005/getJiaojie
      // let res1 = await get("/getJiajia");
      // let res1 = await get("http://localhost:8081/bid/getAuction");
      let res1 = await get('https://tz.admin.tianzesk.com/bid/getAuction')
      // console.info("----getData res1-----", res1);
      if (res1 && res1.data.list) {
        let list = res1.data.list
        // console.info("----getData res1 list-----", list);
        this.bidItems = list
          .map((item) => {
            item.status =
              { 1: '待开拍', 2: '正在竞价', 3: '已结束' }[item.state] ||
              item.state
            item.time = item.endTime
            if (item.state != 3) {
              item.time = `${item.startTime.split(' ')[1]}-${
                item.endTime.split(' ')[1]
              }`
            }
            return item
          })
          .sort((a, b) => b.startTime.localeCompare(a.startTime))
        // console.info("----getData res1 this.bidItems-----", this.bidItems);
      }
      // 指数信息
      let formdata = new FormData()
      formdata.append('day', '30')
      let res2 = await post('http://tz.admin.tianzesk.com/marketvaluedetail/getIndexInfo', formdata)
      // console.info("----getData res2-----", res2);
      if (res2) {
        // let list = Object.values(res2);
        // for (const item of list) {
        //   const { pinming } = item;
        //   item.current = JSON.parse(item['1r'])[0] || {}
        //   item.current.name = pinming;
        //   let arr = JSON.parse(item['5r']);
        //   item.dateArr = arr.map(item=> item.createTime.split(' ')[0])
        //   item.dataArr = arr.map(item=> parseFloat(item.detailLatestpri))
        // }
        // const listall=list.filter(item=> item['1r'] !== '[]')

        // 过滤掉 data 数组中 dataTotal 为空的项
        const indexData = Array.isArray(res2.data) ? res2.data : []
        this.indexItems = indexData.filter(item => item && item.dataTotal && item.dataTotal.length)
      }
      let res4 = await get('http://tz.admin.tianzesk.com/tz/web/trading')
      if (res4.data) {
        this.orderItems = res4.data.map((item) => {
          var {
            createTime,
            categoryName,
            quantity,
            price,
            money,
            buyerCompanyName
          } = item
          createTime = createTime.substring(0, 10)
          quantity = parseInt(quantity)
          price = parseInt(price)
          money = parseInt(money)
          return [
            createTime,
            categoryName,
            quantity,
            price,
            money,
            buyerCompanyName
          ]
        })
      }

      // let res3 = await get("http://localhost:8081/tradeOrder/Mall/getTurnover");
      let res3 = await get('http://tz.admin.tianzesk.com/tradeOrder/Mall/getTurnover')
      if (res3 && res3.data.list) {
        let list = res3.data.list
        var total = 0// parseInt(res3.price || '0');
        var map = {}
        this.summaryMap.total = total + chengjiao + parseInt(res3.data.price || '0')
        this.summaryMap.order = list.length + jiaoyishu
        this.originOrderCount = list.length
        this.originTotalAmount = total + parseInt(res3.data.price || '0')

        let parseData = parse(list)
        for (const item of parseData) {
          const { period, currentVolume, tsName, arrow } = item
          // 当前周期成交量为0的不显示
          if (currentVolume === 0) continue
          let key = period
          if (!map[key]) {
            map[key] = []
          }
          let arrowMap = { 'up': '<span style="color:#f8a036; font-size:18px">⇧</span>', 'down': '<span style="color:#25e49c;font-size:18px">⇩</span>', '=': '--' }
          map[key].push([tsName, currentVolume, arrowMap[arrow]])
        }
        //  console.info('--map--', map)
        this.turnoverItems = map
      }
    }
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url("./img/bg.png");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: row;
    padding: 10px 20px;
  }

  .div-main {
    margin: 20px;
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    // background-color: red;
  }
}
</style>
